import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../Common/tokenDecoder';

export default {
    GetAllOperationEntityByGroupID,
    GetCollectionCategoryByOperationEntityID,
    getFilterExportCollection,
    saveRegularCollectionPoint,
    getCollectionPointByID,
    editData,
    getCollectionPointCategories
};


async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function GetCollectionCategoryByOperationEntityID(operationEntityID) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', 'operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"]

    }
    return divisionArray;
}

async function getCollectionPointCategories() {
    const response = await CommonGet('/api/CollectionPointCategory/GetAllCollectionPointCategories', null)
    var collectionPointcategoryArray = []
    for (let item of Object.entries(response.data)) {
        
            collectionPointcategoryArray[item[1]["collectionPointCategoryID"]] = item[1]["collectionPointTypeName"]
    }
    return collectionPointcategoryArray;
}


async function getFilterExportCollection(data) {
    var routeFilterModel = {
        groupID: data.groupID,
        operationEntityID: data.operationEntityID,
        collectionCategoryID: data.collectionCategoryID,
        collectionPointCategoryID:((data.collectionPointCategoryID=="0"||data.collectionPointCategoryID==null)?null:data.collectionPointCategoryID)
    }
    const response = await CommonPost('/api/CollectionPoint/FilterRegularCollectionPoint', null, routeFilterModel);
    return response.data;

}

async function saveRegularCollectionPoint(data) {
    let save = {
        collectionPointCode: data.collectionPointCode,
        collectionPointName: data.collectionPointName.trim(),
        collectionPointLocation: data.collectionPointLocation,
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID: parseInt(data.collectionCategoryID),
        collectionPointCategoryID:parseInt(data.collectionPointCategoryID),
        createdDate: new Date().toISOString(),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        isActive: data.isActive,
        groupID: parseInt(data.groupID),
    }
    const response = await CommonPost('/api/CollectionPoint/InsertRegularCollectionPoint', null, save);
    return response;
}
async function getCollectionPointByID(id) {
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointById', 'id=' + id);
    return response.data;
}
async function editData(data) {
    data.collectionPointID = parseInt(data.collectionPointID);
    data.modifiedDate = new Date().toISOString();
    let update = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID: parseInt(data.collectionCategoryID),
        collectionPointCode: data.collectionPointCode,
        collectionPointName: data.collectionPointName.trim(),
        collectionPointLocation: data.collectionPointLocation.trim(),
        isActive: data.isActive,
        collectionPointID: parseInt(data.collectionPointID),
        modifiedDate: new Date().toISOString(),
        operationEntityTypeID: parseInt(data.operationEntityTypeID),
        collectionPointCategoryID: parseInt(data.collectionPointCategoryID),
        factoryWeighValidationEnabled: data.factoryWeighValidationEnabled,
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/CollectionPoint/UpdateRegularCollectionPoint', null, update);
    return response;
}
